import { AlignmentType, BorderStyle, HeadingLevel, PageBreak, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";

function numberToWords(num) {
    const words = [
        "zero", "one", "two", "three", "four", "five",
        "six", "seven", "eight", "nine", "ten",
        "eleven", "twelve", "thirteen", "fourteen", "fifteen",
        "sixteen", "seventeen", "eighteen", "nineteen", "twenty",
        "twenty-one", "twenty-two", "twenty-three", "twenty-four", "twenty-five",
        "twenty-six", "twenty-seven", "twenty-eight", "twenty-nine", "thirty"
    ];

    if (num <= 30) return words[num];
    return num.toString();
}

export function observartionSummaryText(vulCount, applicationName) {
    const vulCountFormatted = `${numberToWords(vulCount)} (${vulCount})`;

    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600, right: 600 },
        spacing: { line: 350, before: 300, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `During the security testing exercise, ISECURION security testing team (hereafter referred as the ‘testing team’) identified ${vulCountFormatted} Vulnerabilities in the ${applicationName}. The vulnerabilities are categorized as per industry framework "Common Vulnerability Scoring System v3.1" i.e., CVSS3.1 scoring. The severity rating represented below is Base Score which represents only the intrinsic characteristics of a vulnerability that are constant over time and across user environments. To enable risk-focused mitigation, these vulnerabilities are summarized in five different categories (Critical, High, Medium, Low and Information).`,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
        ],
    })
}

export const summaryNote = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 276, before: 300, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Note: ",
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            bold: true,
            italics: true
        }),
        new TextRun({
            text: "Business units should supplement the base CVSS score with the contextual analysis of the environment, and with attributes that may change over time by leveraging CVSS Temporal and Environmental Metrics. More appropriately, a comprehensive risk assessment system should be employed that considers more factors than simply the CVSS Base Score and represent actual risk.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: true
        }),
    ],
})

export const mapping = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 276, before: 600, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "CVSS 3.1 MAPPING",
            size: 28,
            font: "Calibri",
            color: "0f0f3f",
            bold: true,
            italics: false
        }),
    ]
})

export const severityCategory = new Table({
    width: { size: 49, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 150 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 172, after: 172 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity Category",
                                    font: "Calibri",
                                    size: 24,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189F9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            spacing: { before: 172, after: 172 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CVSS Score Range",
                                    font: "Calibri",
                                    size: 24,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189F9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Critical",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "97CFFE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "9.0 - 10",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "97CFFE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "High",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "7.0 - 8.9",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Medium",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "97CFFE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "4.0 - 6.9",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "97CFFE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Low",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.1 - 3.9",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Informational",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "97CFFE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 140, after: 140 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.0",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "97CFFE", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),
    ]
})

export const exploitation = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 276, before: 800, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Ease of Exploitation",
            size: 28,
            font: "Calibri",
            color: "0f0f3f",
            bold: true,
            italics: false
        }),
    ]
})

export const exploitationTable = new Table({
    width: { size: 89, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,

    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 15, type: WidthType.PERCENTAGE },

                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Easy",
                                    font: "Calibri",
                                    size: 24,
                                    color: "0f0f3f",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ff0000" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 85, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,

                    children: [
                        new Paragraph({
                            indent: { left: 60, right: 60 },
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires little-to-no technical/application knowledge on behalf of an attacker and can be exploited using standard operating system tools.",
                                    font: "Calibri",
                                    size: 24,
                                    color: "0f0f3f",
                                    italics: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Moderate",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFC000", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: { left: 60, right: 60 },
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires some technical/application knowledge for an attacker to exploit, which could be performed using standard operating system tools or tools downloaded from the Internet.",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Difficult",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFF00", },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: { left: 60, right: 60 },
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires specific technical/application knowledge on behalf of an attacker. The issue could be exploited using a combination of operating system tools or publicly available tools downloaded from the Internet.",
                                    font: "Calibri",
                                    size: 24,
                                    color: '0f0f3f',
                                    italics: false,
                                }),

                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        })
    ]
})

export const ratingTableSentence = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { before: 50, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    pageBreakBefore: true,
    children: [
        new TextRun({
            text: "The scale shown below has been used to rate the level of risk:",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: true
        }),
    ],
})

export const vulnerabilityTable = new Table({
    width: { size: 89, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    borders: {
        top: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        bottom: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        left: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        right: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
    },

    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Rating",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "1b3661",
                    },
                    indent: {
                        left: 600
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "1b3661",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "C (Critical)",
                                    font: "Calibri",
                                    size: 22,
                                    color: 'ffffff',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "c00000",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [

                        new Paragraph({
                            indent: {
                                left: 100,
                                right: 100
                            },
                            shading: {
                                type: ShadingType.SOLID,
                                color: "c00000",
                            },
                            spacing: { line: 276, },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Critical vulnerability has a high potential of impacting business operations leading to downtime or disruption and provides an attacker with privileged access, customer service or SLA breach resulting in significant outage. If exploited, it has a direct impact on confidentiality, integrity or availability of organizational information.",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false,
                                    color: "ffffff"
                                }),
                            ]
                        }),
                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "c00000",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "H (High)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ff0000",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "High vulnerability has a high potential of impacting business operations leading to downtime or disruption. This type of vulnerability can be exploited publicly, workaround or fix/patch available by vendor.",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),

                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ff0000",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "M (Medium)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffc000",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Medium vulnerability has a potential of indirectly giving access to an intruder and/or doesn’t have the features enabled for collecting evidence or notifying the attacker of unauthorized use for taking the legal action in case the vulnerability gets exploited. This type of vulnerability upon exploitation might result in elevation of privileges or slowing down the operations.",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),
                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffc000",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "L (Low)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffff00",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Low vulnerability has the potential of revealing the information about the device and may lead to unauthorized access to system leading to compromise. Higher work factor would be involved for exploiting this type of vulnerability.",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),

                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffff00",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "I (Informational)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "00b050",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "These vulnerabilities are relatively very low risk or no risk but must be addressed in subsequent development cycle to avoid any future exposure.",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),
                            ]
                        }),
                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "00b050",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),

    ]
})
